import { render, staticRenderFns } from "./PurchasesTableCustomFilterModal.vue?vue&type=template&id=7532087d"
import script from "./PurchasesTableCustomFilterModal.vue?vue&type=script&lang=js"
export * from "./PurchasesTableCustomFilterModal.vue?vue&type=script&lang=js"
import style0 from "./PurchasesTableCustomFilterModal.vue?vue&type=style&index=0&id=7532087d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports